<template>
  <div id="ExhibitionMobile" class="car-show">
    <div class="main_bg">
      <!-- 视频弹框-->
      <div class="video-wrapper" v-if="videoShow">
        <img
          src="../../assets/exhibition-cd24th/imgsMobile/btn-close-m.png"
          @click="videoShow = false"
        />
        <video height="195" controls autoplay>
          <source :src="playUrl" type="video/mp4" />
        </video>
      </div>
      <!-- 图片弹框-->
      <div class="video-wrapper" v-if="show">
        <img
          src="../../assets/exhibition-cd24th/imgsMobile/btn-close-m.png"
          @click="show = false"
        />
        <div>
          <img :src="imgUrl" style="width: 100%; height: 100%; margin: 0px" />
        </div>
      </div>
      <!-- KV -->
      <div class="banner"></div>
      <!-- 文章-->
      <section class="hight-car">
        <el-carousel
          indicator-position="outside"
          arrow="none"
          style="width: 100%"
          height="40rem"
        >
          <el-carousel-item v-for="(item, index) in workspace4" :key="index">
            <div class="hight-item">
              <div class="content">
                <div class="layout-flex-2">
                  <img class="image" :src="item.imgurlMobile" />
                </div>
                <div class="layout-flex-1">
                  <div class="show-h4">{{ item.title }}</div>
                  <div class="blue-border"></div>
                  <div style="margin-top: 8px" class="show-h6">
                    {{ item.content }}
                  </div>
                  <div class="btn-wrapper">
                    <span
                      class="detail-btn"
                      @click="handleDetail(item.url)"
                    ></span>
                  </div>
                </div>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </section>

      <!-- 亮点车型-->
      <section class="hight-car">
        <div class="show-h5">亮点车型</div>
        <div
          class="hight-item"
          v-for="(item, index) in workspace5"
          :key="index"
        >
          <div class="content">
            <div class="layout-flex-2">
              <img class="image" :src="item.imgurlMobile" />
            </div>
            <div class="layout-flex-1">
              <div class="show-h4">{{ item.title }}</div>
              <div class="blue-border"></div>
              <div style="margin-top: 8px" class="show-h6">
                {{ item.content }}
              </div>
              <div class="btn-wrapper">
                <span class="detail-btn" @click="handleDetail(item.url)"></span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- 现场花絮-->
      <section class="live-wrapper">
        <div class="show-h5" style="margin-top: 33px">现场花絮</div>
        <div style="margin-top: 25px">
          <el-carousel
            arrow="always"
            indicator-position="none"
            type="card"
            height="125px"
            :autoplay="false"
          >
            <el-carousel-item v-for="item in images" :key="item">
              <img
                @click="previewImg(item)"
                class="swiper-item"
                :src="item"
                alt=""
              />
            </el-carousel-item>
          </el-carousel>
        </div>
      </section>
      <!-- 新车赏析-->
      <section>
        <div class="show-h5" style="margin-top: 49px">新车赏析</div>
        <div class="new-radio-box" style="margin-top: 30px">
          <div class="new-radio-wrapper" id="new-radio-wrapper">
            <div class="new-radio-group">
              <span
                @click="handleBtn7(item.key)"
                :class="{ 'is-active': newActive === item.key }"
                class="radio-button"
                v-for="item in workspace7"
                :key="item.key"
                >{{ item.title }}</span
              >
            </div>
          </div>
        </div>
        <div class="news-wrapper">
          <mt-swipe class="news-swipe" :showIndicators="false" :auto="0">
            <mt-swipe-item v-for="(item, index) in newsList" :key="index">
              <img
                width="100%"
                :src="item.imgurl"
                @click="handleDetail(item.url)"
              />
              <div class="news-content" @click="handleDetail(item.url)">
                <div class="show-h4">{{ item.title }}</div>
                <div class="blue-border"></div>
                <div style="margin-top: 8px" class="show-h2">
                  {{ item.content }}
                </div>
              </div>
            </mt-swipe-item>
          </mt-swipe>
          <div class="new-btns">
            <span><</span>左右滑动查看更多<span>></span>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
import config from "./config";

export default {
  data() {
    return {
      ...config,
      videoShow: false,
      show: false,
      playUrl: "",
      imgUrl: "",
      index: 0,
      images: config.workspace60bigMobile,
      newActive: "workspace70",
      newsList: config.workspace70,
      liveActive: "1",
    };
  },
  watch: {
    show() {
      document.body.style.overflow = this.show ? "hidden" : "auto";
    },
    videoShow() {
      document.body.style.overflow = this.videoShow ? "hidden" : "auto";
    },
    liveActive() {
      this.images = config.workspace60big;
    },
  },
  mounted() {},
  methods: {
    // 花絮图片放大
    previewImg(url) {
      this.show = true;
      this.imgUrl = url;
    },
    // 视频放大播放
    handlePlay(url) {
      if (!url) return;
      this.playUrl = url;
      this.videoShow = true;
    },
    // 详情
    handleDetail(url) {
      if (!url) return;
      window.open(url, "_blank");
    },
    // 新车赏析按钮
    handleBtn7(key) {
      this.newActive = key;
      switch (key) {
        case "workspace70":
          this.newsList = this.workspace70;
          break;
        case "workspace71":
          this.newsList = this.workspace71;
          break;
        case "workspace72":
          this.newsList = this.workspace72;
          break;
      }
    },
  },
};
</script>
<style lang="less" scoped>

/deep/.el-carousel__button {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}

.main_bg {
  background: url("../../assets/exhibition-cd24th/imgsMobile/kv@2x.png");
  background-size: 100% 100%;
}
//背景图
.banner {
  height: 500px;
}

.car-show {
  font-family: "Microsoft Yahei", "微软雅黑";
  color: #fff;
  box-sizing: border-box;
  img {
    display: block;
    width: 100%;
  }
  .banner {
    width: 100%;
  }

  .news-swipe {
    height: 340px;
  }
  .swiper-item {
    display: block;
    width: 100%;
    height: 100%;
  }
  .video-wrapper {
    top: 0;
    z-index: 9999;
    position: fixed;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.7);
    padding: 0 15px;
    box-sizing: border-box;
    img {
      width: 18px;
      height: 18px;
      display: block;
      margin-left: calc(100% - 18px);
      margin-bottom: 10px;
    }
    video {
      width: 100%;
    }
  }

  .el-carousel__arrow {
    width: 17px;
    height: 20px;
    background: #000000;
    opacity: 0.7;
    border-radius: 2px;
  }
  .radio-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .new-radio-box {
    width: 100%;
    height: 32px;
    overflow: hidden;
  }
  .new-radio-wrapper {
    width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
    height: 42px;
    padding: 0 15px;
    box-sizing: border-box;
    transition: all 0.5s;
    /*&::-webkit-scrollbar {*/
    /*  width: 0px;*/
    /*  height: 0px;*/
    /*}*/
  }

  // 列表
  .hight-item {
    width: 100%;
    height: 432px;
    position: relative;
    .content {
      position: absolute;
      top: 0px;
      left: 15px;
      right: 15px;
    }

    .layout-flex-1 {
      padding: 20px 10px;
      background: #1a3e55;
    }

    .layout-flex-2 {
    }
  }

  // 按钮
  .btn-wrapper {
    margin-top: 18px;
    span {
      display: inline-block;
      width: 112px;
      height: 28.5px;
      cursor: pointer;
    }
    .detail-btn {
      background: url("../../assets/exhibition-cd24th/imgsMobile/btn1@2x.png")
        100% 100%;
      background-size: 100% 100%;
    }
    .car-btn {
      margin-left: 29.5px;
      background: url("../../assets/exhibition-cd24th/imgsMobile/btn1@2x.png")
        100% 100%;
      background-size: 100% 100%;
    }
  }

  // 标题
  .new-radio-group {
    height: 30px;
    display: flex;
    align-content: center;
    justify-content: space-between;
    overflow: hidden;

    .radio-button {
      display: inline-block;
      width: 110px;
      height: 30px;
      font-size: 14px;
      font-weight: bold;
      text-align: center;
      line-height: 30px;
      color: #fff;
      cursor: pointer;
      box-sizing: border-box;
      background: url("../../assets/exhibition-cd24th/imgsMobile/btn-bg4a@2x.png");
      background-size: 100% 100%;

      &.is-active {
        background: url("../../assets/exhibition-cd24th/imgsMobile/btn-bg4@2x.png");
        background-size: 100% 100%;
      }
    }
  }

  // 新闻版块
  .news-wrapper {
    width: 100%;
    height: 426px;
    padding: 20px 15px;
    box-sizing: border-box;
    margin-top: 25px;
    .news-content {
      background: #1a3e55;
      width: 100%;
      height: 136px;
      box-sizing: border-box;
      padding: 19px 15px;
    }

    .blue-border {
      width: 20px;
      height: 3px;
      background: #2f81b2;
      margin-top: 8px;
    }

    .new-btns {
      color: white;
      font-size: 12px;
      text-align: center;
      margin-top: 20px;
      span {
        font-size: 14px;
        margin: 0 13px;
      }
    }
  }
}

.show-h1 {
  font-weight: bold;
  font-size: 13px;
  line-height: 22px;
  margin-top: 26px;
}
.show-h3 {
  font-weight: bold;
  font-size: 12px;
  line-height: 20px;
}
.show-h4 {
  font-weight: bold;
  font-size: 14px;
  line-height: 20px;
}
.show-h5 {
  font-weight: bold;
  font-size: 22px;
  line-height: 20px;
  text-align: center;
  margin: 10px 0 28px 0;
}
.show-h2 {
  font-weight: 400;
  font-size: 10px;
  line-height: 16px;
  overflow: hidden; //将超出的部分隐藏
  text-overflow: ellipsis; //超出部分用省略号显示
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  margin-top: 14px;
}
.show-h6 {
  font-weight: 400;
  font-size: 10px;
  line-height: 16px;
  margin-top: 14px;
}
</style>
